import { useEffect, useState } from "react";
import "./PageLoader.css";

const PageLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3 segundos

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="loader-container">
      <img 
        src="/images/logo.png" 
        alt="Loading..." 
        className="loader-image" 
      />
    </div>
  );
};

export default PageLoader;